const STORAGE_KEY = "treydora_pending_trdx_purchase";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;

/**
 * Persist in-flight TRDX ETH purchase until chain confirm + optional backend sync.
 * @param {{
 *   txHash: string,
 *   walletAddress: string,
 *   chainId: number,
 *   trdxAmount?: string,
 *   ethAmountWei?: string,
 *   phase?: 'submitted' | 'confirmed' | 'sync_failed',
 * }} data
 */
export function setPendingTrdxPurchase(data) {
  try {
    const txHash = String(data?.txHash || "").trim();
    const walletAddress = String(data?.walletAddress || "").trim();
    if (!txHash || !walletAddress) return;
    const chainId = Number(data?.chainId);
    const payload = {
      txHash,
      walletAddress,
      chainId: Number.isFinite(chainId) ? chainId : undefined,
      trdxAmount: String(data?.trdxAmount || "").trim(),
      ethAmountWei: String(data?.ethAmountWei || "").trim(),
      phase: data?.phase === "confirmed" || data?.phase === "sync_failed" ? data.phase : "submitted",
      ts: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* noop */
  }
}

/** @returns {object | null} */
export function getPendingTrdxPurchase() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o || typeof o !== "object" || !o.txHash) return null;
    if (typeof o.ts !== "number" || Date.now() - o.ts > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return o;
  } catch {
    return null;
  }
}

export function clearPendingTrdxPurchase() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* noop */
  }
}
